import React from 'react';
import cx from 'classnames';
import styles from './ProgressBar.m.sass';
export default function ProgressBar(_ref) {
  var bars = _ref.bars;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.progress
  }, bars.map(function (props, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: cx(styles.progressBar, props.style === 'striped' && styles.progressBarStriped),
      style: {
        width: "".concat(props.progress, "%")
      }
    });
  }));
}
//# sourceMappingURL=index.js.map
